/** Normalises a tag so "Long Hair", "long_hair" and " LONG-HAIR " all compare equal. */
export function normalizeTagForMatch(tag: string): string {
  return tag.trim().toLowerCase().replace(/[\s_-]+/g, "_")
}

/** A search exclusion ("-solo") removes posts that carry that exact tag. Exact, not substring, so excluding "solo" keeps
 * "solo_focus" and excluding "man" keeps "woman". Posts that carry no tag data at all are kept, since there is nothing to
 * judge them by. */
export function postHasExcludedTag(postTags: string[] | undefined | null, excludedTags: string[]): boolean {
  if (!postTags?.length || !excludedTags.length) return false
  const excluded = new Set(excludedTags.map(normalizeTagForMatch).filter(Boolean))
  if (!excluded.size) return false
  return postTags.some((tag) => excluded.has(normalizeTagForMatch(tag)))
}
